import React, { useEffect, useState, useCallback, useRef, useMemo, memo } from 'react';
import { AgGridReact } from 'ag-grid-react';

const CustomAgGridTable = ({ rowDatas, columnDefss, onColumnMoved,
    onSortChanged, onFilterChanged,
    styles, gridApiOptions, onGridReady, ...gridProperties }) => {
    const [columnDefs, setColumnDefs] = useState(columnDefss);
    const [rowData, setRowData] = useState(rowDatas);
    const [gridApi, setGridApi] = useState(null);


    // Apply pinned/lockPinned to first two columns
    useEffect(() => {
        if (columnDefss && columnDefss.length > 0) {
            const updatedDefs = columnDefss.map((colDef, index) => {
                if (index < 2) {
                    return {
                        ...colDef,
                        pinned: 'left',
                        suppressHorizontalScroll: false,
                        lockPinned: true,
                    };
                }
                return colDef;
            });
            setColumnDefs(updatedDefs);
        }
    }, [columnDefss]);



    useEffect(() => {
        if (gridApi) {
            gridApi.setRowData(rowDatas);
        } else {
            setRowData(rowDatas);
        }
    }, [rowDatas, gridApi]);

    useEffect(() => {
    }, [rowDatas, columnDefss]);

    return (
        <div>
            <div className="ag-theme-material"
                style={{
                    height: rowData && rowData.length === 0 ? '500px' : 'auto',
                    width: '100%',
                    overflowX: 'auto',
                    ...styles,
                }}
            >
                <AgGridReact
                    columnDefs={columnDefs}
                    rowData={rowData}
                    onGridReady={onGridReady}
                    onColumnMoved={onColumnMoved}
                    onSortChanged={onSortChanged}
                    onFilterChanged={onFilterChanged}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        resizable: true,
                    }}
                    {...gridApiOptions}
                    {...gridProperties}
                    suppressRowClickSelection={true}
                    overlayLoadingTemplate=""
                    // suppressNoRowsOverlay={true}
                    suppressCellSelection={true}
                    overlayNoRowsTemplate={`<span style="padding: 10px; font-size: 13px;">No Data To Show</span>`}
                />
            </div>
        </div>
    );
};

export default CustomAgGridTable;



// WEBPACK FOOTER //
// ./src/Common-Table/CustomAgGridTable.js